// extracted by mini-css-extract-plugin
export default {"header":"edit-purchases-modal_header__IBZY+","content":"edit-purchases-modal_content__Vwkyz"};